import { render, staticRenderFns } from "./Personbank.vue?vue&type=template&id=c7a84282&scoped=true&"
import script from "./Personbank.vue?vue&type=script&lang=js&"
export * from "./Personbank.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/content.css?vue&type=style&index=0&id=c7a84282&scoped=true&lang=css&"
import style1 from "./Personbank.vue?vue&type=style&index=1&id=c7a84282&scoped=true&lang=css&"
import style2 from "./Personbank.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a84282",
  null
  
)

export default component.exports